
// import { PropType } from 'vue'
// import Vue, { PropType } from 'vue'
// import { mapGetters } from 'vuex'
import toggleArrayItemMixin from '@/mixins/toggleArrayItemMixin'

import cloneDeep from 'lodash.clonedeep'

import JDateField from '@/ui/controls/JDateField.vue'
import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JFileInput from '@/ui/controls/JFileInput.vue'

// import { formatDate } from '@/helpers/dateHelpers';
import Plant from '@/models/Plant'
import Harvest from '@/models/Harvest'
// import Harvest from '@/models/Harvest';
import { id } from '@/types/models'
import JFileContainer from '@/models/JFileContainer'

import { HarvestInput, HarvestUpdate } from '@/types/store'

// import { uploadFileToFirestore } from '@/firebase/storage'

// const DEFAULT_HARVEST_ITEM: HarvestInput = {
//   date: formatDate(new Date()),
//   quantity: 1,
//   quality: undefined,
//   ripeness: undefined,
//   size: undefined,
//   traits: [],
//   note: null,
// }

interface DialogObject {
  show: boolean
  value?: string
}

interface HarvestNumberInput {
  quantity: number
}

// const getKeyValue = <T extends object, U extends keyof T>(key: U) => (obj: T) => obj[key];

export default toggleArrayItemMixin.extend({
  components: {
    JDateField,
    PlantAvatar,
    JFileInput,
  },
  // mixins: [toggleArrayItemMixin],
  props: {
    // value: [String as PropType<id>, Array as PropType<id[]>],
    // value: Array as PropType<id[]>,
    gardenId: String,
    plantId: String,
    harvestId: String,
    // fullscreen: Boolean,
  },
  data: () => ({
    input: undefined as unknown as HarvestInput, // cloneDeep(DEFAULT_HARVEST_ITEM) as HarvestInput,
    images: [] as Array<JFileContainer>,

    submitting: false,
    additionalTraits: [] as string[],

    additionalTraitDialog: {
      show: false,
      value: undefined,
    } as DialogObject,

    showAllTraits: false,
  }),
  computed: {
    plants(): Array<Plant> {
      return this.$store.getters['gardens/plants/inGarden'](this.gardenId)
    },
    fullscreen(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    plant(): Plant {
      return this.$store.getters['gardens/plants/find'](this.plantId)
    },
    harvest(): Harvest {
      return this.$store.getters['gardens/plants/harvests/find'](this.harvestId)
    },
    allTraitItems(): string[] {
      return [...new Set([...this.traitItems, ...this.additionalTraits])]
    },
    traitItems(): string[] {
      return this.plants
        .map((p: Plant) => p.harvests.map((h: Harvest) => h.traits || []))
        .flat(2)
    },
  },
  watch: {
    harvestId: {
      immediate: true,
      handler(newVal): void {
        const h = this.$store.getters['gardens/plants/harvests/find'](newVal)
        // console.log(h)
        this.input = cloneDeep(h)
      },
    },
  },
  methods: {
    inc(key: keyof HarvestInput) {
      this.input[key]++
    },
    dec(key: keyof HarvestInput): void {
      if (Number(this.input[key]) > 1) this.input[key]--
    },
    close(): void {
      this.$router.go(-1)
    },
    onCloseClick(): void {
      this.close()
    },
    onPlantChange(e: id): void {
      this.$emit('input', [e])
    },
    // onFileChange(v: Array<JFileContainer>) {
    //   this.images = v
    // },
    addAdditionalTrait(newTrait?: string, autoselect = true): void {
      if (!newTrait || newTrait.trim().length < 1) {
        this.$store.dispatch('snackbars/error', 'Invalid trait')
        return
      }
      this.additionalTraits.push(newTrait)
      this.additionalTraitDialog.value = undefined
      this.additionalTraitDialog.show = false
      if (autoselect) this.toggleArrayItem(newTrait, this.input.traits)
    },

    isInvalid() {
      const isIntegerGreaterThan = (val: number, min = 0) =>
        Number.isInteger(val) && val > min
      const isNumberBetween = (val?: number, min = 1, max = 5) =>
        typeof val === 'number' && val >= min && val <= max

      if (!this.plantId) return 'select plant'
      if (!this.input.date) return 'select a date'
      if (!isIntegerGreaterThan(this.input.quantity, 0))
        return 'invalid quantity'
      if (!isNumberBetween(this.input.quality, 0, 5)) return 'invalid quality'
      if (!isNumberBetween(this.input.ripeness)) return 'invalid ripeness'
      if (!isNumberBetween(this.input.size)) return 'invalid size'
    },
    onInputQuantityBlur(e: Event): void {
      const target = e.target as HTMLInputElement
      this.input.quantity = Number(target.value)
    },
    // resetInput(defaultObj = DEFAULT_HARVEST_ITEM): void {
    //   this.input = cloneDeep(defaultObj)
    //   this.images = []
    // },
    submitAndClose(): void {
      this.submit(true)
    },
    // submitAndClear(): void {
    //   this.submit()
    //     .then(() => this.resetInput())
    // },
    submit(closeOnSuccess = false): Promise<object[]> {
      // validate form
      const isInvalid = this.isInvalid()
      if (isInvalid) {
        this.$store.dispatch('snackbars/error', isInvalid)
        throw Error(isInvalid)
      }

      if (!this.input) {
        throw new Error('input is undefined')
      }

      const input = this.input || ({} as HarvestInput)

      // find changesthis.$store.dispatch('snackbars/error', 'input is undefined')
      const changeableKeys = [
        'date',
        'quantity',
        'quality',
        'ripeness',
        'size',
        'traits',
        'note',
      ] as Array<keyof HarvestInput>

      function isEqual<T>(a: T, b: T, comparer = (a: T, b: T) => a === b) {
        return comparer(a, b)
      }

      function isEqualJSON<T>(a: T, b: T) {
        return JSON.stringify(a) === JSON.stringify(b)
      }

      function isEqualValue<T>(a: T, b: T) {
        return a === b
      }

      const updates = {} as HarvestUpdate

      changeableKeys.forEach((key) => {
        const comparer =
          this.harvest[key] && Array.isArray(this.harvest[key])
            ? isEqualJSON
            : isEqualValue

        if (
          !isEqual<string | number | string[] | null>(
            input[key] || null,
            this.harvest[key] || null,
            comparer
          )
        ) {
          updates[key] = input[key] || null
        }
      })

      if (Object.keys(updates).length <= 0) {
        this.$store.dispatch('snackbars/warn', 'no updates')
        throw new Error('no updates')
      }

      // console.log(this.input, this.harvest, updates)
      // console.log(this.gardenId, this.plantId, this.harvestId)

      this.submitting = true
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('gardens/plants/harvests/update', {
            gardenId: this.gardenId,
            plantId: this.plantId,
            harvestId: this.harvestId,
            updates,
          })
          .then((res) => {
            if (closeOnSuccess) this.close()
            resolve(res)
          })
          .then(() =>
            this.$store.dispatch(
              'snackbars/add',
              `Updated ${this.plant.name} harvest`
            )
          )
          .catch((err) => {
            this.$store.dispatch('snackbars/error', err.message)
            reject(err)
          })
          .finally(() => (this.submitting = false))
      })
    },
  },
})
